<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-invisible`]" width="1em" height="1em" v-bind="$attrs"><path d="M24 30c-1.315 0-2.601-.104-3.849-.302l-.996 3.717a1 1 0 01-1.224.708l-1.932-.518a1 1 0 01-.707-1.225l.975-3.64a22.219 22.219 0 01-4.553-2.14l-3.178 3.178a1 1 0 01-1.415 0l-1.414-1.414a1 1 0 010-1.414l2.8-2.8a18.11 18.11 0 01-3.563-4.577l-.141-.27-.169-.34a1 1 0 01.191-1.14l.292-.29a7.98 7.98 0 01.154-.143l.718-.652c.102-.094.197-.183.287-.27l.194-.192a.898.898 0 011.41.162l.052.1C10.422 22.123 16.386 26 24 26c7.296 0 13.399-3.773 15.848-8.952.067-.14.14-.31.218-.508a.85.85 0 011.303-.36l.087.075 1.664 1.664a1 1 0 01.188 1.152l-.213.419c-.099.19-.187.352-.264.485a18.302 18.302 0 01-3.606 4.422l2.553 2.553a1 1 0 010 1.414l-1.414 1.414a1 1 0 01-1.414 0l-2.984-2.984a22.281 22.281 0 01-4.233 1.946l.975 3.64a1 1 0 01-.707 1.225l-1.932.518a1 1 0 01-1.224-.708l-.996-3.717A24.539 24.539 0 0124 30z"/></svg>
</template>
<script>

export default {
  name: 'IconInvisible',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
